import dayjs from "dayjs";
import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { getSystemBootstrap } from "@/api/system";

export const useSystemContextStore = defineStore("system-context", () => {
  const currentProject = ref<{ id: string; code: string; name: string } | null>(
    null,
  );
  const projects = ref<
    Array<{ id: string; code: string; name: string; status: string }>
  >([]);
  const dictionaries = ref<
    Record<string, Array<{ value: string; label: string }>>
  >({});
  const features = ref({
    ai: false,
    crm: false,
    crmSaas: false,
    personalViews: true,
    reports: true,
    notifications: true,
  });
  const businessDate = ref(dayjs().format("YYYY-MM-DD"));
  const timezone = ref("Asia/Singapore");
  const loaded = ref(false);

  const projectLabel = computed(
    () => currentProject.value?.name ?? "全部授权项目",
  );

  async function load() {
    if (loaded.value) return;
    try {
      const response = await getSystemBootstrap();
      currentProject.value = response.data.context.currentProject;
      businessDate.value = response.data.context.businessDate;
      timezone.value = response.data.context.timezone;
      projects.value = response.data.projects;
      dictionaries.value = response.data.dictionaries;
      features.value = response.data.features;
    } finally {
      loaded.value = true;
    }
  }

  function selectProject(id: string | null) {
    currentProject.value =
      projects.value.find((item) => item.id === id) ?? null;
  }
  function options(code: string) {
    return dictionaries.value[code] ?? [];
  }

  return {
    currentProject,
    projects,
    dictionaries,
    features,
    businessDate,
    timezone,
    projectLabel,
    loaded,
    load,
    selectProject,
    options,
  };
});
